import { Navigate, useLocation } from "react-router-dom";
import UserData from "../Controls/UserData";
import Helpers from "../Controls/helpers";

/** Redirect to dashboard when the user lacks hiring admin roles. */
export function RequireHiring({ children }) {
  const userData = UserData.UserData() || {};
  if (!Helpers.canHire(userData)) {
    return <Navigate to="/dashboard" replace />;
  }
  const pending = Helpers.pendingRequiredAgreements(userData);
  if (pending.length > 0) {
    const id = pending[0].AgreementID || pending[0].agreementID;
    return (
      <Navigate
        to={"/agreementSignature/" + id}
        replace
        state={{ returnTo: "/recruit" }}
      />
    );
  }
  return children;
}

/** Redirect to dashboard when the user is not a SysAdmin. */
export function RequireSysAdmin({ children }) {
  const userData = UserData.UserData() || {};
  if (!Helpers.isSysAdmin(userData)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

/** Soft gate: if required agreements pending on hiring routes, send to sign. */
export function AgreementHiringGate({ children }) {
  const location = useLocation();
  const userData = UserData.UserData() || {};
  if (
    Helpers.isGatedHiringPath(location.pathname) &&
    !Helpers.isAgreementEscapePath(location.pathname)
  ) {
    const pending = Helpers.pendingRequiredAgreements(userData);
    if (pending.length > 0) {
      const id = pending[0].AgreementID || pending[0].agreementID;
      return (
        <Navigate
          to={"/agreementSignature/" + id}
          replace
          state={{ returnTo: location.pathname }}
        />
      );
    }
  }
  return children;
}
